// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/technical-record-keeping.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/technical-record-keeping/journey-log-making-correcting-retaining.js';
import g1 from '../lessons/air-law/technical-record-keeping/technical-record-keeping.js';

mount([g0, g1]);
